export default {
  apiKey: "AIzaSyDhIW1Coa4FMnG4Vn-EQcmawEFi8BiXrCg",
  authDomain: "ogrenci-c90f9.firebaseapp.com",
  databaseURL: "https://ogrenci-c90f9.firebaseio.com",
  projectId: "ogrenci-c90f9",
  storageBucket: "ogrenci-c90f9.appspot.com",
  messagingSenderId: "525620084948",
  appId: "1:525620084948:web:ef29a1324ac4e6fe1fbb41",
  measurementId: "G-EQJWDRRF66",
};
